import classNames from "classnames";
import { ReactNode } from "react";

export const PageHeader = ({
  header,
  className = "",
}: {
  header: ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={classNames(
        "text-32 font-fraunces font-medium text-grey-950",
        className,
      )}
    >
      {header}
    </div>
  );
};
